import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CourierService } from '../../../shared/services/courier.service';
import { ActiveUserLocalDataService } from '../../../shared/services/active-user-local-data.service';
import { TranslateService } from '@ngx-translate/core';
import { GetActiveVoucherDto} from '../../../shared/models/courier.models';

@Component({
  templateUrl: 'visual-damage-action-pick.component.html',
  styleUrls: ['./visual-damage-action-pick.component.scss']
})
export class VisualDamageActionPickComponent implements OnInit {
  loading: boolean = true;
  type: string = '';
  voucher: GetActiveVoucherDto | null = null;

  constructor(
    private courierService: CourierService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    const url = this.router.url;

    if (url.endsWith('/service-visual-damage-action-pick')) {
      this.voucher = this.activeUserLocalDataService.activeServiceVoucher;
    } else if (url.endsWith('/visual-damage-action-pick')) {
      this.voucher = this.activeUserLocalDataService.getActiveCourierVoucher();
    }

    if (!this.voucher) {
      this.navigateToVoucher();
      return;
    }

    this.type = this.activeUserLocalDataService.visualDamageType;
    this.activeUserLocalDataService.visualDamageType = '';
    this.loading = false;
  }

  pickAddNew() {
    this.activeUserLocalDataService.visualDamageType = this.type;
    if (this.voucher?.isServiceVoucher) {
      this.router.navigate(['/service-visual-damage-deffect-position-pick']);
    } else {
      this.router.navigate(['/visual-damage-deffect-position-pick']);
    }
  }

  pickView() {
    this.activeUserLocalDataService.visualDamageType = this.type;
    if (this.voucher?.isServiceVoucher) {
      this.router.navigate(['/service-visual-damage/xxx']);
    } else {
      this.router.navigate(['/visualDamage/xxx']);
    }
  }

  backClick() {
    if (this.voucher?.isServiceVoucher) {
      this.router.navigate(['/service-visual-damage-pick-type']);
    } else {
      this.router.navigate(['/visual-damage-pick-type']);
    }
  }

  navigateToVoucher() {
    if (this.voucher?.isServiceVoucher) {
      this.router.navigate(['/service-voucher']);
    } else {
      this.router.navigate(['/voucher']);
    }
  }

  getPageTitle(): string {
    if (this.type === 'd') {
      return this.translate.instant('VisualDefectOrDamageDetection');
    } else if (this.type === 'c') {
      return this.translate.instant('RegistrationOfARoadTrafficAccident');
    } else {
      return this.translate.instant('IncorrectType');
    }
  }
}